import React, { Component } from 'react';

import { withFixedTitle } from 'src/components';

import Nightingale from 'src/charts/nightingale';

const SquishlessNightingale = withFixedTitle(Nightingale);

/* eslint-disable react/prop-types */

export default class Top7Chart extends Component {
  constructor(props) {
    super(props);
    const { objects, selectedTop7Factor, selectedIndex, eventEmitter } = props;
    const selectedPxScore = objects[selectedIndex].pxScores.find(
      (pxScore) => pxScore.trait.code === selectedTop7Factor
    );
    this.state = {
      selectedTop7Factor,
      selectedPxScore,
    };
    eventEmitter.subscribe('top7FactorChanged', (code) => {
      this.setState({ selectedTop7Factor: code });
    });
  }

  componentDidMount() {
    const { selectedPxScore } = this.state;
    const { eventEmitter } = this.props;
    eventEmitter.dispatch('traitChanged', selectedPxScore.trait);
    eventEmitter.dispatch('scoreChanged', selectedPxScore.score);
  }

  static getDerivedStateFromProps(props, state) {
    const { selectedTop7Factor, selectedPxScore: currentPxScore } = state;
    const { objects, selectedIndex, eventEmitter } = props;
    const selectedPxScore = objects[selectedIndex].pxScores.find(
      (pxScore) => pxScore.trait.code === selectedTop7Factor
    );
    if (currentPxScore !== selectedPxScore) {
      eventEmitter.dispatch('traitChanged', selectedPxScore.trait);
      eventEmitter.dispatch('scoreChanged', selectedPxScore.score);
    }
    return null;
  }

  render() {
    const { objects, top7Labels, top7Series, style, selectedIndex, eventEmitter } = this.props;
    const { selectedTop7Factor } = this.state;
    return (
      <SquishlessNightingale
        title="Actionable Personality Traits"
        labels={top7Labels}
        series={top7Series}
        style={style}
        relativeColors={false}
        shade
        selected={selectedTop7Factor}
        onClick={(code) => {
          const selectedPxScore = objects[selectedIndex].pxScores.find((pxScore) => pxScore.trait.code === code);
          eventEmitter.dispatch('top7FactorChanged', code);
          eventEmitter.dispatch('traitChanged', selectedPxScore.trait);
          eventEmitter.dispatch('scoreChanged', selectedPxScore.score);
        }}
        showRange
        showRangeControl
      />
    );
  }
}
